// Central definition for all SignalR hybrid message names.
export const HYBRID_MESSAGE = [
  'onPingReqMsgReceived',

  // Metadata
  'onListItemMsgReceived',
  'onCallTypesMsgReceived',
  'onConfigurationMsgReceived',
  'onGendercodeMsgReceived',
  'onListFacilityMsgReceived',
  'onPriorityMsgReceived',
  'onPostUpdateMsgReceived',
  'onNatureMsgReceived',
  'onCallSourceMsgReceived',

  // Unit
  'onUnitsMsgReceived',
  'onUnitMsgReceived',
  'onUnitTemplatesMsgReceived',
  'onVehiclesMsgReceived',
  'onVehicleUpdateMsgReceived',
  'onCrewListMsgReceived',

  // Trip
  'onTripUpdateMsgReceived',
  'onTripUnitCandidateRespMsgReceived',
  'onCallTakingRequiredFieldsMsgReceived',
  'onUnitEteRespMsgReceived',
  'TripSearchRespMsg',

  // Patient
  'onPatientListRespMsgReceived',

  // Status
  'onStatusMsgReceived',
];

export type SignalRHybridMessageMethod = typeof HYBRID_MESSAGE[number];

// Maps a hybrid SignalR method name (e.g. onStatusMsgReceived) to the message mType (e.g. StatusMsg).
// Some hybrid payloads omit mType, so we infer it from the method name.
export const HYBRID_METHOD_TO_MTYPE: Record<SignalRHybridMessageMethod, string> = HYBRID_MESSAGE.reduce(
  (acc, methodName) => {
    const inferred = methodName.startsWith('on') && methodName.endsWith('Received')
      ? methodName.substring(2, methodName.length - 'Received'.length)
      : methodName;

    acc[methodName] = inferred;
    return acc;
  },
  {} as Record<SignalRHybridMessageMethod, string>,
);
